import { render, staticRenderFns } from "./merdeka-center.vue?vue&type=template&id=0535323a&scoped=true"
import script from "./merdeka-center.vue?vue&type=script&lang=js"
export * from "./merdeka-center.vue?vue&type=script&lang=js"
import style0 from "./merdeka-center.vue?vue&type=style&index=0&id=0535323a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535323a",
  null
  
)

export default component.exports